import { render, staticRenderFns } from "./TabelaPontosAdicionais.vue?vue&type=template&id=0f5fe39a&"
import script from "./TabelaPontosAdicionais.vue?vue&type=script&lang=js&"
export * from "./TabelaPontosAdicionais.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPontosAdicionais.vue?vue&type=style&index=0&id=0f5fe39a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports